import { render, staticRenderFns } from "./ApplicantTable.vue?vue&type=template&id=5455175a&scoped=true"
import script from "./ApplicantTable.vue?vue&type=script&lang=js"
export * from "./ApplicantTable.vue?vue&type=script&lang=js"
import style0 from "./ApplicantTable.vue?vue&type=style&index=0&id=5455175a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5455175a",
  null
  
)

export default component.exports